// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import ArrowLeftLineSvg from '@rsuite/icon-font/lib/direction/ArrowLeftLine';
var ArrowLeftLine = createSvgIcon({
    as: ArrowLeftLineSvg,
    ariaLabel: 'arrow left line',
    category: 'direction',
    displayName: 'ArrowLeftLine'
});
export default ArrowLeftLine;
